/**
 * @generated SignedSource<<834023d7f0314fe8e5962f6e892c4636>>
 * @relayHash 6a42dba0e2f55d85a4e53a29287ca269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476

import type { ConcreteRequest } from 'relay-runtime';
export type useSpacesDataAnonymousSpacesQuery$variables = Record<PropertyKey, never>;
export type useSpacesDataAnonymousSpacesQuery$data = {
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly alias: string | null;
      readonly icon: {
        readonly path: string;
      } | null;
      readonly id: string | null;
      readonly key: string | null;
      readonly name: string | null;
      readonly status: string | null;
    } | null> | null;
  } | null;
};
export type useSpacesDataAnonymousSpacesQuery = {
  response: useSpacesDataAnonymousSpacesQuery$data;
  variables: useSpacesDataAnonymousSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "spaces(first:10)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpacesDataAnonymousSpacesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSpacesDataAnonymousSpacesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6a42dba0e2f55d85a4e53a29287ca269",
    "id": "5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476",
    "metadata": {},
    "name": "useSpacesDataAnonymousSpacesQuery",
    "operationKind": "query",
    "text": "query useSpacesDataAnonymousSpacesQuery{spaces(first:10){nodes{alias,id,name,key,status,icon{path}}}}"
  }
};
})();

(node as any).hash = "7f837e22c8d2b27a827944523b07b786";

export default node;
